import { useEnrollmentStore } from '@/stores'

export const readStoreDraftFormData = () => useEnrollmentStore.getState().formData

export const readDraftString = (
  storeValue: string | null | undefined,
  storedValue: unknown
) => {
  if (typeof storeValue === 'string' && storeValue.trim()) {
    return storeValue
  }

  if (typeof storedValue === 'string' && storedValue.trim()) {
    return storedValue.trim()
  }

  return ''
}

export const readDraftBooleanString = (
  storeValue: boolean | null | undefined,
  storedValue: unknown
) => {
  if (typeof storeValue === 'boolean') {
    return String(storeValue)
  }

  if (typeof storedValue === 'boolean') {
    return String(storedValue)
  }

  return ''
}

export const readDraftNumberString = (
  storeValue: number | null | undefined,
  storedValue: unknown
) => {
  if (typeof storeValue === 'number' && Number.isFinite(storeValue)) {
    return String(storeValue)
  }

  if (typeof storedValue === 'number' && Number.isFinite(storedValue)) {
    return String(storedValue)
  }

  return ''
}

export const hasRecentDraftApplicationData = () => {
  const storedAt = useEnrollmentStore.getState().formData.applicationReadyAt
  const value = storedAt
  const applicationReadyTtlMs = 2 * 60 * 60 * 1000

  return typeof value === 'number' && Number.isFinite(value) && Date.now() - value < applicationReadyTtlMs
}
